import { render } from "./XlsImport.vue?vue&type=template&id=1cc10dc8&scoped=true"
import script from "./XlsImport.vue?vue&type=script&lang=js"
export * from "./XlsImport.vue?vue&type=script&lang=js"

import "./XlsImport.vue?vue&type=style&index=0&id=1cc10dc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cc10dc8"]])

export default __exports__